import { Resource } from '@opentelemetry/resources';
import {
  propagation,
  ROOT_CONTEXT,
  defaultTextMapGetter,
} from '@opentelemetry/api';

const isGetter = (obj, key) => {
  const descriptor = Object.getOwnPropertyDescriptor(obj, key);

  return !!descriptor && typeof descriptor.get === 'function';
};

export const getTraceparentMeta = (TRACE_PARENT_HEADER) => {
  const metaElement = Array.from(
    document.getElementsByTagName('meta') || [],
  ).find((e) => e.getAttribute('name') === TRACE_PARENT_HEADER);

  return metaElement?.content || '';
};

export const getTraceparentAttributes = (TRACE_PARENT_HEADER) => {
  const metaElement = getTraceparentMeta(TRACE_PARENT_HEADER);

  if (!metaElement) {
    return {};
  }

  const [version, traceId, spanId, sampleDecision] = metaElement.split('-');

  const attributes = {};

  if (version) {
    attributes[`${TRACE_PARENT_HEADER}.version`] = version;
  }

  if (traceId) {
    attributes[`${TRACE_PARENT_HEADER}.trace_id`] = traceId;
  }

  if (spanId) {
    attributes[`${TRACE_PARENT_HEADER}.span_id`] = spanId;
  }

  if (sampleDecision) {
    attributes[`${TRACE_PARENT_HEADER}.sampled`] = sampleDecision;
  }

  return attributes;
};

export function getResources(localResources, context, TRACE_PARENT_HEADER) {
  const resources = Object.entries(localResources).reduce(
    (acc, [key, value]) => {
      if (isGetter(localResources, key)) {
        acc[key] = value;
      } else {
        acc[key] = context[value];
      }

      return acc;
    },
    {},
  );

  return new Resource({
    ...resources,
    ...getTraceparentAttributes(TRACE_PARENT_HEADER),
  });
}

export const getBrowserContext = (traceparent) =>
  propagation.extract(ROOT_CONTEXT, { traceparent }, defaultTextMapGetter);

export function getTraceparentMetaContext(useMetaTraceparent) {
  if (!useMetaTraceparent) {
    return getBrowserContext('');
  }

  return getBrowserContext(getTraceparentMeta());
}
